import { state } from './state'
import { mutations } from './mutations'
import { actions } from './actions'
import { getters } from './getters'

const surveyModule = {
  namespaced: true,
  state: () => ({
    ...state
  }),
  mutations,
  actions,
  getters
}

export default surveyModule
